<template>
  <keep-alive v-if="isKeepAlive">
    <router-view :key="$route.key" />
  </keep-alive>
  <router-view v-else :key="$route.key" />
</template>
<script>
export default {
  name: 'RouteView',
  props: {
    keepAlive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    isKeepAlive() {
      const { $route: { meta } } = this
      return this.keepAlive || meta.keepAlive
    }
  }
}
</script>
